import React from 'react';
import ReactDOM from 'react-dom';
import {detect} from 'detect-browser';
import {unregister} from './registerServiceWorker';
import {getAudioContextForIos} from "./utils/audioUtility";
import adapter from 'webrtc-adapter';
import {setupKeyboardDetection} from "./utils/screenUtility";

const browser = detect() || {};

let handleTouchStart = () => {
    const browserVersion = parseInt(browser.version, 10);
    if (browser.name !== 'ios' || browserVersion >= 13) {
        getAudioContextForIos();
    }
    window.removeEventListener('touchstart', handleTouchStart);
};
window.addEventListener('touchstart', handleTouchStart);

window.addEventListener('load', async () => {
    if (navigator?.serviceWorker) {
        try{
           const reg = await navigator.serviceWorker.register('sw.js', {scope: './'})
        } catch (e) {
            console.log(e, 'serviceWorker')
        }
    }
})
if(window.matchMedia('(display-mode: standalone)').matches) document.documentElement.classList.add('standalone-pwa')

setupKeyboardDetection();

function getContainer() {
    console.log(adapter.browserDetails);
    const browserVersion = parseInt(browser.version, 10);
    if (browser.name === 'ie' || (browser.name === 'safari' && browserVersion < 9) || browser.name === 'edge') {
        const UnsupportedBrowserContainer = require('./containers/unsupportedBrowser').default;
        return <UnsupportedBrowserContainer/>;
    }
    const BaseContainer = require('./containers/base').default;
    return <BaseContainer/>;
}

ReactDOM.render(
    getContainer(),
    document.getElementById('root')
);
